export default class CAJA1050RequestModel {}
